module.exports = __webpack_public_path__ + "img/doors.8de1e6e0.svg";